import { Injectable } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { FaviconService } from '../favicon/favicon.service'

@Injectable()
export class PageTitleNumberService {
    private currentTitle: string = null
    private currentNotificationsCount = 0
    private isWindowVisible = true

    constructor (
        private titleService: Title,
        private favicon: FaviconService,
    ) {
        document.addEventListener('visibilitychange', () => {
            this.onVisibilityChanged()
        }, false)
    }

    public onVisibilityChanged() {
        if (document.hidden) {
            this.isWindowVisible = false
        } else {
            this.isWindowVisible = true
            this.resetCount()
        }
    }

    public increaseNotificationsCount(): void {
        if (this.isWindowVisible) {
            return
        }

        if (this.currentTitle == null) {
            this.currentTitle = this.titleService.getTitle()
        }

        this.currentNotificationsCount++
        this.favicon.increment()
        this.titleService.setTitle(`(${this.currentNotificationsCount}) - ${this.currentTitle}`)
    }

    public resetCount(): void {
        if (this.currentTitle === null || this.currentNotificationsCount === 0) {
            return
        }
        this.titleService.setTitle(this.currentTitle)
        this.currentTitle = null
        this.currentNotificationsCount = 0
        this.favicon.reset()
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/page-title-number/page-title-number.service.ts